// HOOKS
import { useState } from "react";
// FUNCTIONS
import { addToArray } from "../../utils/array/addToArray.array.utils";
import { removeFromArray } from "../../utils/array/removeFromArray.array.utils";

const useSelectAll = () => {
  const [selectAll, setSelectAll] = useState(false);

  const handleSelectAll = (selectedItems, items, id) => {
    // Toggle selectAll
    setSelectAll(!selectAll);
    // Add current items to selectedItems
    if (!selectAll) {
      const updatedSelectedItems = addToArray(selectedItems, items, id);
      return updatedSelectedItems;
    }
    // Remove current items from selectedItems
    if (selectAll) {
      const updatedSelectedItems = removeFromArray(selectedItems, items, id);
      return updatedSelectedItems;
    }
  };

  const resetSelectAll = () => {
    setSelectAll(false);
  };

  return { selectAll, handleSelectAll, resetSelectAll, setSelectAll };
};

export default useSelectAll;
